import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { AccessibleTreeview } from '@bingads-webui/accessible-treeview';
import { getList, getViewNameById } from './intelligence-sub-sections';
import template from './intelligence-tree-bars-template.pug';

export default class UtilitesTreeBars extends DeterministicView {
  initialize() {
    this.treeView = new AccessibleTreeview({
      nodeTemplate: template,
    });
    this.keyHierarchy = [1, 1];
    this.treeView.on('selected', (keyHierarchy) => {
      const [groupIndex, subSectionIndex] = keyHierarchy;
      const index = _.isUndefined(groupIndex) ? [] : [groupIndex];

      if (!_.isUndefined(subSectionIndex)) {
        index.push(subSectionIndex);
      }

      if (index.length > 0) {
        this.trigger('selected', { name: getViewNameById(index) });
      }
      this.keyHierarchy = keyHierarchy;
    });
  }

  renderTrunk() {
    super.renderTrunk();
    this.$el.html(this.treeView.render().el);
    this.treeView.update({ rootNode: getList() });
    this.treeView.select({ keyHierarchy: this.keyHierarchy });

    return this;
  }
}
